Postlogin.AssessmentAssignmentStudentProgress = (function () {
    const $studentProgressTable = $('#student-progress-table');
    const progressBars = [];

    const setupProgressBars = function () {
        if ($('.progress-indicator').length) {
            $('.progress-indicator').each(function () {
                const progress = $(this).attr('data-progress');
                const userId = $(this).attr('data-user-id');
                const barProgress = new ProgressBar.Line(`#${$(this).attr('id')}`, {
                    strokeWidth: 3,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#000',
                    trailColor: '#eee',
                    trailWidth: 3,
                    svgStyle: { width: '100%', height: '100%' },
                    from: { color: '#CDCD00' },
                    to: { color: '#1A9D5A' },
                    step(state, bar) {
                        bar.path.setAttribute('stroke', state.color);
                        bar.setText(`${Math.round(bar.value() * 100)} %`);
                    },
                });
                barProgress.animate(progress / 100); // Value from 0.0 to 1.0
                progressBars[userId] = barProgress;
            });
        }
    };

    const initBootstrapTable = function () {
        const assignmentId = $studentProgressTable.data('assignment-id');
        const assessmentId = $studentProgressTable.data('assessment-id');

        const columns = [
            {
                title: '<i class="fa fa-check text-success" aria-hidden="true"></i>',
                field: 'completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (value, row) => {
                    let progressIndicator = '';
                    if (+row.progress === 100) progressIndicator = 'fa-square-check text-success';
                    if (row.progress < 100 && row.progress > 33) progressIndicator = 'fa-square';

                    return `<i class="fa-regular ${progressIndicator} aria-hidden="true" />`;
                },
            },
            {
                title: 'Name',
                field: 'student',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Completed',
                field: 'date_completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Progress',
                field: 'progress',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (value, row) => `
                        <div
                            class="progress-indicator hidden-print"
                            id="student-progress-${row.user_id}"
                            data-progress="${row.progress}"
                            data-user-id="${row.user_id}"
                            ></div>
                        <span class="visible-print">${row.progress}%</span>
                    `,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
        ];

        $studentProgressTable.bootstrapTable({
            formatNoMatches() {
                return 'No activity to show';
            },
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'activity_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: `/assessments/${assessmentId}/assignments/${assignmentId}/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const queryParams = {};
                queryParams.search_term = params.searchText;
                queryParams.page = params.pageNumber;
                queryParams.page_size = params.pageSize;
                queryParams.order_by = params.sortName;
                queryParams.sort_order = params.sortOrder;

                return queryParams;
            },
            columns,
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    let row = result;
                    const dateFormat = 'llll';
                    const timeagoArray = [];
                    row = Jr.Utils.convertRowDate(row, dateFormat, timeagoArray);

                    if (row.subtitle) {
                        row.cluster += `<br><em>${row.subtitle}</em>`;
                    }

                    const userViewUrl = $studentProgressTable.data('user-view-url').replace(':user_id', row.user_id);
                    let name = $.trim(`${row.first_name} ${row.last_name}`);
                    if (name !== '') {
                        name += '<br>';
                    }
                    row.student = `<a href="${userViewUrl}">${name}(${row.username})</a>`;

                    row.actions = '';
                    if (row.progress > 0) {
                        const assessmentViewUrl = $studentProgressTable
                            .data('ccis-assessment-view-url')
                            .replace(':user_id', row.user_id)
                            .replace(':user_assessment_id', row.user_assessment_id);
                        row.actions += `<a href="${assessmentViewUrl}" class="btn btn-hollow-pink">See ${
                            +row.progress === 100 ? '' : 'Partial '
                        }Results</a>`;
                    }
                });

                return formattedResult;
            },
            onLoadSuccess() {
                setupProgressBars();
            },
            rowStyle(row) {
                let classes = '';
                if (row.progress < 33.3333) {
                    classes += 'danger ';
                } else if (row.progress < 66.6666) {
                    classes += 'warning ';
                } else if (row.progress < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    const init = function () {
        initBootstrapTable();

        $('#export').on('click', (e) => {
            e.preventDefault();
            const opts = $('#student-progress-table').bootstrapTable('getOptions');

            exportParams = {
                columns: _.map($('#student-progress-table').bootstrapTable('getVisibleColumns'), (col) => col.field),
                order_by: opts.sortName,
                sort_order: opts.sortOrder,
                page_size: 9999999,
                browser_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            };

            const exportUrl = $('#export').attr('href');
            window.open(`${exportUrl}?${$.param(exportParams)}`, '_blank');
        });
    };

    return {
        init,
    };
}());
